import {ImageVM} from "./ImageVM.model";
/**
 * Created by saeed on 12/29/2016.
 */
export const STATUS_CREATED:string = "CREATED";
export const STATUS_OK:string = "OK";
export class PaymentResultVM {
  status:string;
  authority:string;
  orderBagId:number;
  free:boolean;
  twoStepBooking:boolean;
  payUrl:string;
  gatewayType:string;
  refId:string;


  constructor() {

  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/PaymentResultVM.model.ts